export const NO_MATCH : string = "Please select one of the provided options";
export const ALREADY_GUESSED : string = "You've already guessed this option!";